import { render, staticRenderFns } from "./MarkAsSeen.vue?vue&type=template&id=2b81ca4c&scoped=true&"
import script from "./MarkAsSeen.vue?vue&type=script&lang=js&"
export * from "./MarkAsSeen.vue?vue&type=script&lang=js&"
import style0 from "./MarkAsSeen.vue?vue&type=style&index=0&id=2b81ca4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b81ca4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
